import { FC, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { formatBoolean } from "../../utils/formatters";
import { CommunityData } from "../../Typings/dataListing";
import { AppDispatch } from "../../redux/store";
import { getCommunityById } from "../../redux/actions/communityAction";

const CommunityView: FC = () => {
  const { communityid } = useParams<{ communityid: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const roleid = localStorage.getItem("roleid") ?? "";
  const { permissions } = usePermissions();
  const [communityData, setCommunityData] = useState<CommunityData | null>(
    null
  );

  useEffect(() => {
    getCommunityData();
  }, [dispatch, communityid]);

  const getCommunityData = async () => {
    if (communityid) {
      const payload = { communityid: parseInt(communityid, 10) };
      try {
        dispatch(
          getCommunityById(payload, (response: any) => {
            if (response?.status !== 500) {
              setCommunityData(response.data);
            }
          })
        );
      } catch (error) {
        console.error("Error fetching community details:", error);
      }
    }
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">F2F Community</span>
              {communityData?.market_name || "N/A"}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Community ID
                <span className="d-block pt-1">
                  {communityData?.communityid || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Market Name
                <span className="d-block pt-1">
                  {communityData?.market_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile Name
                <span className="d-block pt-1">
                  {communityData?.profile_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile ID
                <span className="d-block pt-1">
                  {communityData?.profile_id || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Created At
                <span className="d-block pt-1">
                  {communityData?.created_at || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Updated At
                <span className="d-block pt-1">
                  {communityData?.updated_at || "-"}
                </span>
              </li>
            </ul>

            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Customers
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.customers)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Municipal
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.municipal)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Producers
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.producers)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Extension
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.extension)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Community Groups
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.community_groups)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Other Advisors
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.advisors_other)}
                </span>
              </li>
            </ul>
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Advisor Explanation 1
                <span className="d-block pt-1">
                  {communityData?.advisors_other_explain || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Advisor Explanation 2
                <span className="d-block pt-1">
                  {communityData?.advisors_other_explain2 || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Advisor Explanation 3
                <span className="d-block pt-1">
                  {communityData?.advisors_other_explain3 || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Advisor Explanation 4
                <span className="d-block pt-1">
                  {communityData?.advisors_other_explain4 || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Advisor Explanation 5
                <span className="d-block pt-1">
                  {communityData?.advisors_other_explain5 || "-"}
                </span>
              </li>
            </ul>

            {/* Online Presence */}
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Newsletter
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.newsletter)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Facebook
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.facebook)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Twitter
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.twitter)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Google
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.google)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Pinterest
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.pinterest)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Other Online Presence
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.online_other)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Other Online Presence Explanation
                <span className="d-block pt-1">
                  {communityData?.online_other_explain || "-"}
                </span>
              </li>
            </ul>
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Annual Report
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.annual_report)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Report Link
                <span className="d-block pt-1">
                  {communityData?.report_link || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Experience Collecting
                <span className="d-block pt-1">
                  {formatBoolean(communityData?.experience_collecting)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Resources Available
                <span className="d-block pt-1">
                  {communityData?.resources_available || "-"}
                </span>
              </li>
            </ul>
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Sponsors
                <span className="d-block pt-1">
                  {communityData?.sponsors || "-"}
                </span>
              </li>
            </ul>

            <div className="pt-5 text-end">
              <NavLink to="/Community">
                <button type="button" className="formBtn cancel">
                  Back to List
                </button>
              </NavLink>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default CommunityView;
